export const BASEURL = "https://v65.medx.med.br/";
// export const BASEURLSUPORTE = "https://medx65-v65teste.azurewebsites.net/";
export const BASEURLSUPORTE = "https://v65.medx.med.br/";
// export const BASEURLLOCAL = "http://localhost:19480/"
export const BASEURLLOCAL = "https://medx65-v65teste.azurewebsites.net/"